import React, { useEffect, useState } from "react";
import * as _ from "lodash"
import useWindowDimensions from "../../../helpers/useWindowDimensions";
import { Button, Spinner } from "react-bootstrap";
import Switch from "react-switch";
import useReactRouter from "use-react-router"
import { useSubscription } from "@apollo/client";
import { CANCELLED, COLOR_APP, COMPLETED } from "../../../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStore, faVideoSlash, faVolumeHigh, faVolumeMute } from "@fortawesome/free-solid-svg-icons";
import useStateRef from "react-usestateref";
import { useToasts } from "react-toast-notifications";
import CreateOrderModal from "./CreateOrderModal";
import { LiveErrorScreen } from "./LiveErrorScreen";
import moment from "moment";
import { useLocation } from 'react-router-dom';
import { SUBSCRIPTION_COMMENT } from "../../../graphql/liveComment/subscription";
import axios from "axios"

// style
function CommentLiveScreen({ endLiveLoading, endLive, liveData, onPlayNoProduct, playNoProduct, fetchLiveStocks, fetchLiveOrders, liveStocks, updateOrder, updateLiveStock }) {
//TODO For create order v2 
// function CommentLiveScreen({ endLiveLoading, endLive, liveData, onPlayNoProduct, playNoProduct, fetchLiveStocks, fetchLiveOrders, liveStocks, updateOrders }) {
    const { height, width } = useWindowDimensions();
    const { addToast } = useToasts()
    const { history, match } = useReactRouter()
    const location = useLocation();
    // const { match } = useReactRouter()

    // State
    const [showCreateOrderModal, setShowCreateOrderModal] = useState(false);
    const [selectedComment, setSelectedComment] = useState();
    const [fbVideoCreatedAt, setFbVideoCreatedAt] = useState();
    const [isLoadingComment, setIsLoadingComment] = useState(false)

    var [liveComments, setLiveComments, liveCommentsRef] = useStateRef([]);


    const _fbLiveId = location.state?.fbLiveId ?? liveData?.live?.fbLiveId;
    const { data: commentData } = useSubscription(SUBSCRIPTION_COMMENT, {
        variables: {
            fbLiveId: _fbLiveId || ''
        }
    });
    // 
    // useEffect
    useEffect(() => {
        if (liveData?.live) {
            if ([COMPLETED, CANCELLED].includes(liveData?.live?.status)) return history.goBack();
            selectLiveVideos(liveData?.live)
        }
    }, [liveData])

    useEffect(() => {
        if (commentData) {
            let _liveComments = [...liveCommentsRef.current]
            _liveComments.unshift(commentData?.onCommentCreated)
            setLiveComments(_liveComments)

        }
    }, [commentData])

    const selectLiveVideos = async (live) => {

        try {
            let liveVideoId = live?.fbLiveId;
            let accessToken = live?.pageAccessToken;
            const url = `https://graph.facebook.com/v21.0/${liveVideoId}/comments?fields=created_time,message,from{id,name,picture},can_reply_privately&limit=100000&order=reverse_chronological&access_token=${accessToken}`;
            const response = await axios.get(url);
            let newComment = response?.data?.data;
            setLiveComments(newComment)
            setIsLoadingComment(false)


        } catch (error) {
            console.log({ error })
            setIsLoadingComment(false)

        } finally {
            setIsLoadingComment(false)
        }
    }


    return (
        <div style={{ overflow: 'scroll', padding: 5, background: '#F5F5FA', border: '1px solid #F5F5FA', borderRadius: 10, height: width > 700 ? "82vh" : "70vh" }}>
            {
                width > 700 && <div style={{ background: "#FFF", borderRadius: 6, margin: 2, padding: 5, display: 'flex', flexDirection: 'column' }}>
                    <div style={{ margin: "10px 2px", padding: "6px 4px", fontSize: 16, fontWeight: 'bold', background: "#F5F5FA", borderRadius: 8, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: 'nowrap' }}>ຫົວຂໍ້ໄລຟ: {liveData?.live?.description}</div>
                    {fbVideoCreatedAt && <pre style={{ fontSize: 14, margin: 0, padding: 0 }}>ເວລາ: {moment((new Date(Date.parse(fbVideoCreatedAt))).toString()).format('DD/MM/YYYY HH:mm A')}</pre>}
                    

                    <div style={{ display: 'flex', margin: '10px 0px', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <FontAwesomeIcon className="mr-2" color={COLOR_APP} icon={playNoProduct ? faVolumeHigh : faVolumeMute} />
                                ປິດ/ເປີດສຽງ
                            </div>
                            <div>
                                <Switch
                                    checked={playNoProduct}
                                    onChange={() => onPlayNoProduct()}
                                    onColor="#4CAF50"
                                    onHandleColor="#2E7D32"
                                    offColor="#ff0000"
                                    offHandleColor="#b71c1c"
                                    handleDiameter={25}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                    height={15}
                                    width={40}
                                    className="react-switch"
                                    id="material-switch"
                                />
                            </div>
                        </div>

                        <div>
                            <Button className="btn btn-danger" style={{ borderRadius: 10, padding: '5px 10px' }}
                                onClick={() => endLive()}
                            >
                                {endLiveLoading ? <Spinner size="sm" animation="border" /> : <FontAwesomeIcon icon={faVideoSlash} />}
                                ສິ້ນສຸດໄລຟ
                            </Button>
                        </div>
                    </div>
                </div>
            }

            <div style={{ color: COLOR_APP, marginTop: 10, fontSize: 14, fontWeight: 'bold' }}>
                {/* <Button size="sm" style={{ background: LINEAR_GRADIENT_BG, color: "#ffffff", border:'none' }} onClick={handleRefreshComment} disabled={isLoadingComment ? true : false} > {isLoadingComment ? (<Spinner size="sm" />) : (<MdOutlineRefresh />)} </Button> */}
                Comment ລູກຄ້າ {liveComments?.length ?? 0} ລາຍການ</div>
            <div style={{ overflow: 'scroll', background: "#FFF", borderRadius: 6, margin: 2, padding: 5, display: 'flex', flexDirection: 'column' }}>
                {liveComments?.map((fbComment, index) => (
                    <div key={index} style={{ display: 'flex', margin: '10px 0px', justifyContent: 'space-between', gap: 10 }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ fontSize: 12, display: 'flex', justifyContent: 'start', alignItems: 'start' }}>
                                {fbComment?.from?.picture ? (
                                    <img className="mr-2" src={fbComment?.from?.picture?.data?.url} alt="fb"
                                        style={{ width: 30, height: 30, borderRadius: 50 }}
                                    />
                                ) : (
                                <img className="mr-2" src="https://img.freepik.com/premium-vector/default-avatar-profile-icon-social-media-user-image-gray-avatar-icon-blank-profile-silhouette-vector-illustration_561158-3383.jpg" alt="fb"
                                    style={{ width: 30, height: 30, borderRadius: 50 }}
                                />
                                )}  
                                <div style={{ padding: 5, borderRadius: 10, 
                                    background: typeof fbComment?.can_reply_privately === 'boolean' ? (!fbComment?.can_reply_privately ? 'green' : '#f2f2f2') : '#f2f2f2' }}>
                                    <p style={{ fontSize: 14, fontWeight: 'bold', color: typeof fbComment?.can_reply_privately === 'boolean' ? (!fbComment?.can_reply_privately ? 'white' : 'black') : 'black' }}>{fbComment?.from?.name ?? fbComment?.name}</p>
                                    <p style={{ fontSize: 13, marginTop: '-1.3em', marginBottom: '-.008px', color: typeof fbComment?.can_reply_privately === 'boolean' ? (!fbComment?.can_reply_privately ? 'white' : 'black') : 'black' }}>{fbComment?.message}
                                        {typeof fbComment?.can_reply_privately === 'boolean' ? (!fbComment?.can_reply_privately ? ' ✅' : ' ❓') : ''}
                                    </p>
                                </div>

                            </div>
                        </div>

                        <div className="ml-2">
                            <Button style={{ fontSize: 12, borderRadius: 6, borderColor: "#5357B6", color: "#5357B6", padding: 2, background: 'transparent' }}
                                // disabled={!fbComment?.can_reply_privately}
                                onClick={() => {
                                    setShowCreateOrderModal(true);
                                    setSelectedComment(fbComment)
                                }}>
                                <FontAwesomeIcon icon={faStore} className="mr-2" />ສ້າງອໍເດີ້
                            </Button>
                        </div>
                    </div>
                ))}
            </div>
            <CreateOrderModal updateOrder={updateOrder} updateLiveStock={updateLiveStock} fetchLiveStocks={fetchLiveStocks} fetchLiveOrders={fetchLiveOrders} liveId={liveData?.live?.id} showCreateOrderModal={showCreateOrderModal} setShowCreateOrderModal={setShowCreateOrderModal} liveStocks={liveStocks} selectedComment={selectedComment} />
            {/* //TODO For create order V2*/}
            {/* <CreateOrderModal
                fetchLiveStocks={fetchLiveStocks} 
                fetchLiveOrders={fetchLiveOrders} 
                showCreateOrderModal={showCreateOrderModal} 
                setShowCreateOrderModal={setShowCreateOrderModal} 
                selectedComment={selectedComment}
                liveStocks={liveStocks} 
                liveData={liveData?.live}
                updateOrders={updateOrders}
            /> */}
            {liveData && <LiveErrorScreen liveData={liveData?.live} playNoProduct={playNoProduct} />}
        </div>
    );
}

export default CommentLiveScreen;
